import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDeleteConfirmStore = defineStore('deleteConfirm', () => {
  const visible = ref(false);
  const title = ref('Delete');
  const message = ref('Are you sure you want to delete this item?');
  const warning = ref('This action cannot be undone.');
  const confirmText = ref('Delete');
  const cancelText = ref('Cancel');

  let resolver = null;

  function resetState () {
    visible.value = false;
    title.value = 'Delete';
    message.value = 'Are you sure you want to delete this item?';
    warning.value = 'This action cannot be undone.';
    confirmText.value = 'Delete';
    cancelText.value = 'Cancel';
    resolver = null;
  }

  function resolveCurrent (result) {
    resolver?.(result);
    resetState();
  }

  function ask (options = {}) {
    if (resolver) {
      resolver(false);
    }

    title.value = options.title || 'Delete';
    message.value = options.message || 'Are you sure you want to delete this item?';
    warning.value = options.warning ?? 'This action cannot be undone.';
    confirmText.value = options.confirmText || 'Delete';
    cancelText.value = options.cancelText || 'Cancel';
    visible.value = true;

    return new Promise((resolve) => {
      resolver = resolve;
    });
  }

  function cancel () {
    resolveCurrent(false);
  }

  function confirm () {
    resolveCurrent(true);
  }

  return {
    visible,
    title,
    message,
    warning,
    confirmText,
    cancelText,
    ask,
    cancel,
    confirm
  };
});
